import config from 'config';

export const OverallFitPosition = {
  MIN: -1,
  MAX: 1,
};

const categories = config.get('public.productCategories');

// These productCategories should be kep in sync with graphql product categories
// graphql code:
// https://git.techstyle.net/projects/grap/repos/product-gql/browse/src/modules/product/config/category-id-mappings.json
export const QuickViewProductCategories = {
  size_shoe: new Set([categories.womensFashionShoes, categories.shoes]),
  size_undie: new Set([
    categories.womensBriefs,
    categories.womenSocks,
    categories.womensThongs,
    categories.mensUnderwear,
    categories.womensActivewearUnderwear,
    categories.mensActivewearUnderwear,
  ]),
  size_bottom: new Set([
    categories.womensFashionBottom,
    categories.womensBottom,
    categories.mensBottom,
  ]),
  size_bra: new Set([categories.womensBra, categories.sportsBra]),
  size_top: new Set([
    categories.womensTop,
    categories.womensActivewearTops,
    categories.sportsBra,
    categories.womensJackets,
    categories.mensTop,
  ]),
};

export const InseamValues = {
  Short: '10894',
  Regular: '10896',
  Tall: '10898',
  '3in': '11589',
  '5in': '11576',
  '7in': '11561',
  '9in': '11562',
  '16in': '10885',
  '17in': '10886',
  '18in': '10887',
  '19in': '10888',
  '20in': '10889',
  '21in': '10890',
  '22in': '10891',
  '23in': '10892',
  '24in': '10893',
  '26in': '10895',
  '28in': '10897',
  '30in': '10899',
  '31in': '10900',
  '32in': '10901',
  '33in': '10902',
  '34in': '10903',
  '35in': '11241',
};

export const SWATCH_TYPES = {
  DEFAULT: 'default',
  CORE: 'Core',
};

export const SWATCH_TYPES_LABEL_MAP = {
  [SWATCH_TYPES.DEFAULT]: 'Limited',
  [SWATCH_TYPES.CORE]: 'Core',
};
